const supabaseAssetBaseUrl = (import.meta.env.VITE_SUPABASE_PUBLIC_ASSET_BASE_URL || '').replace(/\/+$/, '');

const localBusinessPictogramFallbacks: Record<string, string> = {
  '/brand/business/extraordinary.webp': '/brand/business/extraordinary.png',
  '/brand/business/food.webp': '/brand/business/food.png',
  '/brand/business/live.webp': '/brand/business/live.png',
};

const localOnlyAssetPaths = new Set([
  '/brand/reference/team-building-card.webp',
  '/brand/reference/privatisation-card.webp',
  '/brand/reference/seminaire-card.webp',
  '/brand/reference/evjf-card.webp',
  '/brand/reference/evg-card.webp',
  '/brand/reference/anniversaire-enfant-card.webp',
  '/brand/reference/anniversaire-enfant-sidebar.webp',
  '/brand/reference/anniversaire-adulte-card.webp',
  '/brand/sidebar-bar/cocktails.webp',
  '/brand/sidebar-bar/service.webp',
  '/brand/sidebar-bar/sign.webp',
  '/brand/sidebar-bar/lounge.webp',
  '/brand/sidebar-bar/group.webp',
  '/brand/pictograms/aztec-quest.svg',
  '/brand/pictograms/magic-school.svg',
  '/brand/pictograms/pirate-bay.svg',
  '/brand/pictograms/stars-zone.svg',
  '/brand/action-game/demineur-card.webp',
  '/brand/action-game/serpent-card.webp',
  '/brand/action-game/bataille-navale-hero.webp',
  '/brand/action-game/gallery-2026/aztec-bazteck.webp',
  '/brand/action-game/gallery-2026/aztec-floor-is-lava.webp',
  '/brand/action-game/gallery-2026/aztec-hypoglouton.webp',
  '/brand/action-game/gallery-2026/magic-labyrinthe.webp',
  '/brand/action-game/gallery-2026/magic-potions.webp',
  '/brand/action-game/gallery-2026/magic-quizball.webp',
  '/brand/action-game/gallery-2026/pirate-bataille-navale.webp',
  '/brand/action-game/gallery-2026/pirate-couloir.webp',
  '/brand/action-game/gallery-2026/pirate-cale-infernale.webp',
  '/brand/action-game/gallery-2026/stars-demineur.webp',
  '/brand/action-game/gallery-2026/stars-hypercube.webp',
  '/brand/action-game/gallery-2026/stars-simon-run.webp',
  '/brand/karaoke/karaoke-party-unsplash.webp',
  '/brand/karaoke/karaoke-friends-unsplash.webp',
  '/brand/karaoke/karaoke-room-group-unsplash.webp',
  '/brand/karaoke/karaoke-duet-unsplash.webp',
  '/brand/karaoke/karaoke-celebration-pexels.webp',
  '/brand/karaoke/karaoke-screen-unsplash.webp',
]);

function normalizeKnownLocalAsset(src: string) {
  const fallback = Object.entries(localBusinessPictogramFallbacks).find(([source]) => src.endsWith(source));
  return fallback ? fallback[1] : src;
}

function shouldStayLocal(src: string) {
  return localOnlyAssetPaths.has(src);
}

function isRoutableLocalAsset(src: string) {
  if (src.startsWith('/brand/timeline/') || src.startsWith('/brand/icons/')) {
    return false;
  }

  if (src.startsWith('/brand/business/') && src.endsWith('.png')) {
    return false;
  }

  return src.startsWith('/brand/') || src.startsWith('/media/');
}

export function resolveMediaUrl(src: string | undefined) {
  if (!src) {
    return src;
  }

  const normalizedSrc = normalizeKnownLocalAsset(src);

  if (shouldStayLocal(normalizedSrc)) {
    return normalizedSrc;
  }

  if (!supabaseAssetBaseUrl || !isRoutableLocalAsset(normalizedSrc)) {
    return normalizedSrc;
  }

  return `${supabaseAssetBaseUrl}/${normalizedSrc.replace(/^\/+/, '')}`;
}
